export default __webpack_public_path__ + "f5e43870d7fb9cfe9445c9e49f8313c6.png";